<template>
  <div class="row">
    <div class="loginBox text-center"> <img class="user" :src="logo_kolegji" height="100px" width="100px">
      <h3>Lajm&euml;rimi</h3>
      <div>
        <div class="inputBox">
          <input id="username" type="text" name="Username" placeholder="Indeksi" required autofocus>
          <input id="password" type="password" name="Password" placeholder="Fjalëkalimi" required>
        </div>
        <input type="submit" class="btn-danger" name="password" value="Kyçu" @click="login();">

        <h5 class="text-danger" v-if="logini"> Indeksi ose Fjalekalimi gabim!</h5>
      </div>
    </div>
  </div>
</template>

<script>
import logo_kolegji from '../assets/img/logo-kolegji.png'
import { APISettings } from '../api/config.js'

export default {
  data()
  {
    return {
      logo_kolegji,
      logini: false,
    }
  },

  methods: {

    login: function ()
    {
      fetch(APISettings.baseURL + 'User/logini', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({

          studenti: document.getElementById("username").value,
          paswordi: document.getElementById("password").value,
        })
      })
        .then(
          (signinResponse) =>
          {
            this.logini = true;
            signinResponse.json().then((res) =>
            {
              if (signinResponse.status === 200)
              {
                var studenti_data = document.getElementById("username").value;

                // set token,index,refreshToken in cookies
                document.cookie = `accesstoken=${res.content.accessToken}`;

                localStorage.setItem("user", studenti_data);

                let text = studenti_data;
                let result = text.replace('/', "%2F");
                document.cookie = `index=${result}`;
                document.cookie = `refresh_token=${res.content.refreshToken}`;

                this.login_dashboard = true;
                this.$router.push('/dashboard')
              } else if (signinResponse.status === 400)
              {

              }
            }
            )
          }).catch(error =>
          {
            this.logini = true;
          })
    },
    gotoLogin()
    {
      if (this.$cookies.get("accesstoken") != null)
      {
        this.$router.push('dashboard');
      }

    },


  },
  beforeMount()
  {
    this.gotoLogin();

  },
}
</script scoped>

<style scoped>
#particles-js {
  height: 100%
}

.loginBox {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
  width: 350px;
  box-shadow: 0 2px 2px rgb(220 59 69 / 50%);
  border-radius: 10px;
  padding: 40px;
}

.user {
  margin: 0 auto;
  display: block;
  margin-bottom: 20px
}

h3 {
  margin: 0;
  padding: 0 0 20px;
  color: #59238F;
  text-align: center
}

.loginBox input {
  width: 100%;
  margin-bottom: 20px
}

.loginBox input[type="text"],
.loginBox input[type="password"] {
  border: none;
  border-bottom: 2px solid #262626;
  outline: none;
  height: 40px;
  color: black;
  background: transparent;
  font-size: 16px;
  padding-left: 20px;
  box-sizing: border-box
}

.loginBox input[type="text"]:hover,
.loginBox input[type="password"]:hover {
  color: black;
  border-radius: 8px;
  box-shadow: 0 2px 2px rgb(220 59 69 / 50%);
}

.loginBox input[type="text"]:focus,
.loginBox input[type="password"]:focus {
  border-bottom: 2px solid black;
}

.inputBox {
  position: relative
}

.inputBox span {
  position: absolute;
  top: 10px;
  color: #262626
}

.loginBox input[type="submit"] {
  border: none;
  outline: none;
  height: 40px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 2px 2px rgb(220 59 69 / 50%);
}

.loginBox a {
  color: #262626;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  display: block
}

a:hover {
  color: #00ffff
}

p {
  color: #0000ff
}

@media(max-width:776px) {
  .loginBox {
    transform: translate(-50%, 25%);
  }
}
</style>

